export default __webpack_public_path__ + "static/media/Diluc1.8cb6d4f3.mp3";